import { ElementRef, Injectable, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ObservablesService } from "./observables.service";
import { EnumService } from "./enum.service";
import { UtilService } from "./util.service";
import { SharedDataService } from './shared-data.service';
import { AbstractControl, FormGroup } from "@angular/forms";
import { ApiService } from "./api.service";
import { environment } from "../../environments/environment";
import { Storage } from "@ionic/storage-angular";
import { SingleChoiceFieldComponent } from '../components/single-choice-field/single-choice-field.component';
import { IonCheckbox } from '@ionic/angular';
import { auditTime } from 'rxjs/operators';
//import { Router, NavigationEnd, NavigationStart } from '@angular/router';
//import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  
  scoringData = {
    enabled:false,
    showScoreInApp:false,
    showTotalScoreInPDF:false,
    showSectionScoreinPDF:false,
    formScore: 0,
    formPossibleScore:0,
    formScorePercent:0,
    sectionScores:[],
    sectionPossibleScores:[],
    AnswerScoreMap:[],
    userAnswerData:[],
    hiddenSections:[],
    hiddenQuestions:[],
    answersInHiddenSections:[],
  }
  answersInHiddenForDeselect:any = []

  firstRun = true
  loadingFormSavedState = false
  cancelUncheckForSavedState = false

  initHiddenQuestions = []
  initHiddenSections = []
  predefinedSectionBoxes = []
  confirmBoxes = []

  recentlyRemovedSections: string[] = [];

  private isRestoringState = false;

  constructor(
    public utilService: UtilService,
    public observablesService: ObservablesService,
    public sharedDataService: SharedDataService,
    //private router: Router
  ) {
    /*
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart || event instanceof NavigationEnd)
    )
    .subscribe(event => {
      if (event instanceof NavigationStart) {
        // Before navigating to the specified page
        if (event.url.includes('/dashboard-qrscan')) {
          this.sharedDataService.scoreStateData = this.scoringData
          this.sharedDataService.savedScoreStateAvailable = true
        }
      } else if (event instanceof NavigationEnd) {
        // After navigating from the specified page
        if (event.urlAfterRedirects.includes('/dashboard-qrscan')) {
        }
      }
    });
    */

  this.utilService.hiddenQuestions$.subscribe((questions) => {
  // console.log('questions ------------------------', questions)

  // Store previous hidden questions to detect changes
  const previousHiddenQuestions = [...this.scoringData.hiddenQuestions];
  this.scoringData.hiddenQuestions = [];
  
  // Track all sections that need score recalculation
  const sectionsToRecalculate = new Set<string>();

  for (const question of questions) {
    if (question.questionId) {
      if (Date.now() < this.sharedDataService.lastSaveStateLaunch + 1000) {
        if ("showForLogic" in question && this.scoringData.userAnswerData) {
          let questionIsAnswered = false;
          for (const userAnswer of this.scoringData.userAnswerData) {
            if (userAnswer.questionId == question.questionId) {
              questionIsAnswered = true;
              question.questionIsHidden = false;
            }
          }
          if (!questionIsAnswered && question.questionIsHidden) {
            this.utilService.addHiddenQuestion(question);
          }
        }
      }
      
      // Always track the section, whether hiding or unhiding
      if (question.sectionID) {
        sectionsToRecalculate.add(question.sectionID);
      }
    } else {
      this.scoringData.userAnswerData = this.scoringData.userAnswerData.filter(
        (answer) => answer.questionId != question
      );
    }
    this.scoringData.hiddenQuestions.push(question.questionId);
  }

  // Also check sections of questions that were previously hidden but are now visible
  // console.log('previousHiddenQuestions ----------------------', previousHiddenQuestions);
  previousHiddenQuestions.forEach(questionId => {
    if (!this.scoringData.hiddenQuestions.includes(questionId)) {
      const question = this.findQuestionById(questionId);
      // console.log('this question is ----------------', question)
      if (question?.sectionID) {
        sectionsToRecalculate.add(question.sectionID);
      }
    }
  });

  // Recalculate scores for all affected sections
  // console.log('sectionsToRecalculate', sectionsToRecalculate);
  sectionsToRecalculate.forEach(sectionId => {
    try {
      const sectionIndex = this.getSectionIndex(sectionId);
      if (sectionIndex >= 0) {
        // Force recalculation by passing true to skip form max calc
        const newMaxScore = this.calculatePossibleSectionScore(sectionId, [], true);
        this.scoringData.sectionPossibleScores[sectionIndex].maxScore = newMaxScore;
        
        // Also update current score for the section
        this.calculateCurrentSectionScore(sectionId, true, true);
        // this.recalculateAllVisibleSections();
        
        // console.log(`Updated scores for section ${sectionId}:`, {
        //   maxScore: newMaxScore,
        //   currentScore: this.scoringData.sectionScores[sectionIndex].score,
        //   userAnswerData: this.scoringData.userAnswerData
        // });
      }
    } catch (error) {
      console.warn('Error recalculating scores for section:', sectionId, error);
    }
  });

  // Recalculate form possible score
  this.calculatePossibleFormScore();

  for (const answerSection of this.scoringData.AnswerScoreMap) {
    if (!answerSection.sectionIsHidden) {
      for (const answerDetails of answerSection.questions) {
        if (!this.scoringData.hiddenQuestions.includes(answerDetails.questionId)) {
          // answerDetails.questionIsHidden = false
        }
      }
    }
  }

  for (const answer of this.scoringData.userAnswerData) {
    let answerIsHidden = false;
    for (const hiddenAnswer of this.scoringData.hiddenQuestions) {
      if (answer.questionId === hiddenAnswer.questionId) {
        answerIsHidden = true;
      }
      answer.hidden = answerIsHidden;
    }
  }

  // console.log("Updated hidden questions:", {
  //   questions: questions,
  //   userAnswerData: this.scoringData.userAnswerData,
  //   hiddenQuestions: this.scoringData.hiddenQuestions,
  //   sectionScores: this.scoringData.sectionScores,
  //   sectionPossibleScores: this.scoringData.sectionPossibleScores,
  //   AnswerScoreMap: JSON.parse(JSON.stringify(this.scoringData.AnswerScoreMap))
  // });
});

    this.utilService.hiddenSections$.subscribe((sections) => {
      this.scoringData.hiddenSections = []
      for (const section of sections){
        this.scoringData.hiddenSections.push(section.sectionId)
      }
      // console.log('this.scoringData.AnswerScoreMap', this.scoringData.AnswerScoreMap);
      // console.log('scoringData', this.scoringData);
      for(const section of this.scoringData.AnswerScoreMap){
        if(!this.scoringData.hiddenSections.includes(section.sectionId)){
          //console.log('trigger now section is hidden true');
          section.sectionIsHidden = false
          //console.log('section id',section.sectionId, 'this is section possible score', this.calculatePossibleSectionScore(section.sectionId));
          try{
            this.scoringData.sectionPossibleScores[this.getSectionIndex(section.sectionId)].maxScore = this.calculatePossibleSectionScore(section.sectionId)
          } catch{}
          // THIS ONE IS RETURNING 0 FOR POSSIBLE SCORES => THE  QUESTION OF SECTION IS STILL IN HIDDENQUESTIONS TABLE
        } 
        else{
          section.sectionIsHidden = true
        }
      }

      // THIS PART IS NOT NEEDED FOR NOW EVEN IN THE OLD
      // for(const section of this.scoringData.AnswerScoreMap){
      //   // if(!this.scoringData.hiddenSections.includes(section.sectionId)){
      //   //   section.sectionIsHidden = false
      //   // } 
      //   // else{
      //   //   section.sectionIsHidden = true
      //   // }
      //   // NEW UPDATE
      //   // if(!this.scoringData.hiddenSections.includes(section.sectionId)){
      //   //   try{this.scoringData.sectionPossibleScores[this.getSectionIndex(section.sectionId)].maxScore = this.calculatePossibleSectionScore(section.sectionId)} catch{}
      //   //   for(const question of section.questions){
      //   //     if(!question.questionIsHidden){
      //   //       this.scoringData.hiddenQuestions = this.scoringData.hiddenQuestions.filter((q)=>{q.questionId != question.questionId})
      //   //     }
      //   //   }
      //   // }
      //   //try{this.scoringData.sectionPossibleScores[this.getSectionIndex(section.sectionId)].maxScore = this.calculatePossibleSectionScore(section.sectionId)} catch{}
      // }
      // console.log('this.scoringData.hiddenSections from subscription', this.scoringData.hiddenSections);
    });

    // this.utilService.addHiddenQuestionTriggered$.subscribe((data) => {
    //   try {
    //     const { questionId, sectionId } = data;
    //     console.log('questionId --- ', questionId, 'sectionId ---- ', sectionId);

    //     // this.scoringData.hiddenQuestions.push(questionId);
    //     // if (this.scoringData.hiddenQuestions.includes(questionId)) {
    //     //   console.log('youpopopop', questionId)
    //     // }
    //     // this.scoringData.userAnswerData = this.scoringData.userAnswerData.filter(
    //     //   answer => answer.questionId !== questionId
    //     // );
    //     //this.scoringData.sectionScores[this.getSectionIndex(sectionId)].score = this.calculateCurrentSectionScore(sectionId, true, true)
    //   } catch (error) {
    //     console.error('Error in addHiddenQuestionTriggered$', error);
    //   }
      
    // });

    

    this.utilService.removeHiddenSectionTriggered$.subscribe((removedSectionId) => {
      // console.log('removeHiddenSectionTriggered', removedSectionId)
      if (removedSectionId) {

        if (!this.recentlyRemovedSections.includes(removedSectionId)) {
          this.recentlyRemovedSections.push(removedSectionId);
        }

        // console.log('removedSectionId', removedSectionId);
        try {
          const index = this.getSectionIndex(removedSectionId);
          const questions = this.scoringData.AnswerScoreMap[index]?.questions || [];
          // console.log('questions from removeHiddenSectionTriggered', questions);
          const questionIdsToRemove = questions.map(q => q.questionId);
          this.scoringData.hiddenQuestions = this.scoringData.hiddenQuestions.filter(
            (hiddenQId) => !questionIdsToRemove.includes(hiddenQId)
          );
          // Propagate the removal to the actual source of truth (util.service's
          // hiddenQuestionsSubject), not just this local mirror. Otherwise these ids
          // stay stuck there forever and get reinstated the next time ANY unrelated
          // question's Show/Hide logic causes hiddenQuestions$ to re-emit.
          questionIdsToRemove.forEach(qId => this.utilService.removeHiddenQuestion(qId));

          this.recalculateAllVisibleSections();
          // console.log(`Removed hidden questions for section ${removedSectionId}:`, questionIdsToRemove);
          if (this.scoringData.sectionPossibleScores[index] !== undefined) {
            // console.log('yeeeey',  this.calculatePossibleSectionScore(removedSectionId))
            const newMaxScore = this.calculatePossibleSectionScore(removedSectionId);
            this.scoringData.sectionPossibleScores[this.getSectionIndex(removedSectionId)].maxScore = newMaxScore;
          }

          setTimeout(() => {
            this.recentlyRemovedSections = this.recentlyRemovedSections.filter(id => id !== removedSectionId);
            //this.recalculateAllVisibleSections();
            // REMOVE QUESTIONS OF removedSectionId FROM hiddenQuestions TABLE
            const sectionQuestions = this.scoringData.AnswerScoreMap.find(s => s.sectionId === removedSectionId)?.questions || [];
          
            const questionIdsToRemove = sectionQuestions.map(q => q.questionId);
          
            // 3. Remove these questions from hiddenQuestions
            this.scoringData.hiddenQuestions = this.scoringData.hiddenQuestions.filter(
              questionId => !questionIdsToRemove.includes(questionId)
            );
            // Same propagation as above - keep util.service's tracked list in sync.
            questionIdsToRemove.forEach(qId => this.utilService.removeHiddenQuestion(qId));
            if (this.getSectionIndex(removedSectionId) !== -1) {
              // this.scoringData.sectionPossibleScores[this.getSectionIndex(removedSectionId)].maxScore = this.calculatePossibleSectionScore(removedSectionId)
              this.scoringData.sectionPossibleScores.forEach((section) => {
                if (!this.scoringData.hiddenSections.includes(section.Id)) {
                  section.maxScore = this.calculatePossibleSectionScore(section.Id);
                  this.calculateCurrentSectionScore(section.Id, true, true);
                }
              });
            }
          }, 500);
        } catch (err) {
          console.error(`Error removing hidden questions for section ${removedSectionId}:`, err);
        }
      }
    });

    this.utilService.hideLogicExecuted$.subscribe(event => {
      if (!event) return;
      
      if (event.type === 'question') {
        // console.log(`Hide logic executed on QUESTION ID: ${event.id}`);
        // Remove answers for this question
        this.scoringData.userAnswerData = this.scoringData.userAnswerData.filter(
          answer => answer.questionId !== event.id
        );
      } else if (event.type === 'section') {
        // console.log(`Hide logic executed on SECTION ID: ${event.id}`);
        // Remove answers for this entire section
        this.scoringData.userAnswerData = this.scoringData.userAnswerData.filter(
          answer => answer.section !== event.id
        );
      }
      
      this.recalculateAllVisibleSections();
    });
    
  }

  private findQuestionById(questionId: string): any {
    for (const section of this.scoringData.AnswerScoreMap) {
      for (const question of section.questions) {
        if (question.questionId === questionId) {
          return question;
        }
      }
    }
    return null;
  }

  private recalculateAllSections(): void {
    this.scoringData.sectionScores = [];
    this.scoringData.sectionPossibleScores = [];

    this.scoringData.AnswerScoreMap.forEach((section, index) => {
      this.scoringData.sectionScores.push({Id: section.sectionId, score: 0});
      const invalidatedScores = [];
      
      for (const answer of this.scoringData.userAnswerData) {
        if (answer.section === section.sectionId && answer.score === "/") {
          invalidatedScores.push(answer.questionId);
        }
      }
      
      this.scoringData.sectionPossibleScores.push({
        Id: section.sectionId, 
        maxScore: this.calculatePossibleSectionScore(
          section.sectionId, 
          invalidatedScores,
          true
        )
      });
    });

    for (const section of this.scoringData.AnswerScoreMap) {
      if (!this.scoringData.hiddenSections.includes(section.sectionId)) {
        this.calculateCurrentSectionScore(section.sectionId, true, true);
      }
    }
  }

  private recalculateAllVisibleSections() {
    // console.log('Current hiddenSections:', this.scoringData.hiddenSections);
    
    this.scoringData.AnswerScoreMap.forEach((section) => {
      if (!this.scoringData.hiddenSections.includes(section.sectionId)) {
        const questionIds = section.questions.map(q => q.questionId);
        this.scoringData.hiddenQuestions = this.scoringData.hiddenQuestions.filter(
          qId => !questionIds.includes(qId)
        );
      }
      // console.log('Current hiddenQuestions: -----------', this.scoringData.hiddenQuestions);
    });

    this.scoringData.sectionPossibleScores.forEach((section) => {
      if (!this.scoringData.hiddenSections.includes(section.Id)) {
        section.maxScore = this.calculatePossibleSectionScore(section.Id);
        this.calculateCurrentSectionScore(section.Id, true, true);
        // console.log(`Recalculated maxScore for section ${section.Id}: ${section.maxScore}`);
      }
    });
    
    this.calculatePossibleFormScore();
    //this.calculateCurrentFormScore();
  }

  calculatePossibleFormScore() {
    this.scoringData.formPossibleScore = 0
    for (const sectionScore of this.scoringData.sectionPossibleScores){
      //if (!this.scoringData.hiddenSections.includes(sectionScore.Id)) {
      if(!this.scoringData.AnswerScoreMap[this.getSectionIndex(sectionScore.Id)].sectionIsHidden){
        this.scoringData.formPossibleScore += sectionScore.maxScore
      }
    }
    this.calculateFormScorePercent()
  }
  calculateCurrentFormScore(){
    this.scoringData.formScore = 0
    for (const sectionScore of this.scoringData.sectionScores){
      if(!this.scoringData.AnswerScoreMap[this.getSectionIndex(sectionScore.Id)].sectionIsHidden &&sectionScore.score != undefined && !isNaN(sectionScore.score)){
        this.scoringData.formScore += sectionScore.score
      }
    }
    // console.log('this.scoringData.formScore', this.scoringData.formScore);
    // console.log('this.scoringData from calculateCurrentFormScore', this.scoringData)
    this.calculateFormScorePercent()
  }
  calculateFormScorePercent(){
    this.scoringData.formScorePercent = Math.round((this.scoringData.formScore/this.scoringData.formPossibleScore) *100)
  }

  calculatePossibleSectionScore(targetSectionId, invalidatedScores = [], skipFormMaxCalc = false) {
    let possibleScore = 0 
    try{
      if(!this.scoringData.hiddenSections.includes(targetSectionId)){
      for (const question of this.scoringData.AnswerScoreMap[this.getSectionIndex(targetSectionId)].questions){
      let questionMax = 0
      //check if / or hidden, if not check if multi or single choice and score acordingly
      // console.log('hiddenSections', this.scoringData.hiddenSections);
      if (invalidatedScores.includes(question.questionId) || question.questionIsHidden || this.scoringData.hiddenQuestions.includes(question.questionId)){
        questionMax = 0
      } else {
        if (question.selectedAnswerTypeId === 2){
          for (const answer of question.answerChoiceAttributes){
            if (answer.answerChoiceAttributeScoreOrWeight !== "/" && answer.answerChoiceAttributeScoreOrWeight >0 && !question.questionIsHidden){
              questionMax += Number(answer.answerChoiceAttributeScoreOrWeight)
            }
          }
        } else {
          for (const answer of question.answerChoiceAttributes){
            if(!(invalidatedScores.includes(answer.answerId)) && answer.answerChoiceAttributeScoreOrWeight !== "/" && Number(answer.answerChoiceAttributeScoreOrWeight) > questionMax && !question.questionIsHidden){
              if(answer.answerChoiceAttributeScoreOrWeight > 0){
                questionMax = Number(answer.answerChoiceAttributeScoreOrWeight)
              }
            }
          }
        }
      }
      possibleScore +=questionMax
    }
  } 
  else{
    //Skip calc for hidden section
    possibleScore = 0
    }
    if (!skipFormMaxCalc){
      this.calculatePossibleFormScore()
    }
  } catch(error){
    if(! error.toString().includes("reading 'questions'")){
      console.warn("Error getting possible score of section: ", targetSectionId, " (Ignore if 0 or section hidden)")
    }
    return 0
  }
    return possibleScore
  }
  lastCurrentCalcTime = 0
  calculateCurrentSectionScore(sectionID, calledFromEvalHidden = false, forceCalculation = false){
    //add up all the current question scores, if a question has a value of \ add it to the list of questions to be ignored
    //debouncing, since showing hidden questions can make this run twice
    // if(Date.now() > this.lastCurrentCalcTime +125){
    //   this.lastCurrentCalcTime = Date.now()
    // } else {return}

    if (!forceCalculation) {
      if (Date.now() > this.lastCurrentCalcTime + 125) {
        this.lastCurrentCalcTime = Date.now();
      } else {
        return;
      }
    }

    if(!calledFromEvalHidden){
      this.evaluateHiddenValues()
    }
    let skipFormMaxCalc = true
    let runningScore = 0
    const invalidatedScores = []
    for(const answer of this.scoringData.userAnswerData){
      if((answer.score == "/" || this.scoringData.hiddenQuestions.includes(answer.questionId)) && answer.questionId !in invalidatedScores ){
        invalidatedScores.push(answer.questionId)
      }
      if(answer.section === true || answer.section === false){
        answer.section = this.resolveBrokenAnswerSectionId(answer.answerChoiceId)
      }
    }
    if (sectionID === 0){
      return 0
    }
    try{
    if(forceCalculation || !this.scoringData.AnswerScoreMap[this.getSectionIndex(sectionID)].sectionIsHidden){
      for(const answer of this.scoringData.userAnswerData){
        if(!answer.hidden){
          if (answer.section === sectionID && !(invalidatedScores.includes(answer.answerId)) && !this.scoringData.hiddenQuestions.includes(answer.questionId)){
            if (answer.score === "/"){
              invalidatedScores.push(answer.questionId)
            } else {
              runningScore += answer.score
            }
          }
        } else{
          skipFormMaxCalc = false
        }
      }
      //check for questions with / and remove the scores, then recalculate the max
      for (const answer of this.scoringData.userAnswerData){
        if (invalidatedScores.includes(answer.questionId)){
          if (answer.score !== "/"){
            runningScore = runningScore - answer.score
          }
        }
      }
    } else{
      skipFormMaxCalc = false
    }
  } catch(error){
    if(!error.toString().includes("reading 'sectionIsHidden'")){
      console.warn("Error calculating current score for section: ", sectionID, " (Ignore if 0 or if the section has no scoring)")
    }
  }
    this.scoringData.sectionPossibleScores[this.getSectionIndex(sectionID)].maxScore =  this.calculatePossibleSectionScore(sectionID, invalidatedScores, skipFormMaxCalc)
    //this.scoringData.sectionScores[this.getSectionIndex(sectionID)].score = runningScore
    this.scoringData.sectionScores[this.getSectionIndex(sectionID)].score = parseInt(runningScore.toString())
    this.calculateCurrentFormScore()
    this.calculatePossibleFormScore()
  }

  getSections(){
    const sectionInfo = []
    for (const currentSection of this.scoringData.AnswerScoreMap){
      const updatedSection = currentSection
      for(const newScore of this.scoringData.sectionScores){
        if(newScore.Id === updatedSection.sectionId){
          updatedSection.achievedSectionScore = newScore.score
        }
      }
      for(const newMax of this.scoringData.sectionPossibleScores){
        if(newMax.Id === updatedSection.sectionId){
          updatedSection.maximumSectionScore = newMax.maxScore
        }
      }
      updatedSection.perSectionScore = Math.round((updatedSection.achievedSectionScore/updatedSection.maximumSectionScore) *100)
      sectionInfo.push(updatedSection)
    }
    //return sectionInfo
    return sectionInfo
  }

  getSectionIndex(sectionId){
    for (let i = 0; i < this.scoringData.sectionScores.length; i++){
      if(sectionId === this.scoringData.sectionScores[i].Id){
        return(i)
      }
    }
    return -1
  }

  prepHeaderSectionInfo(){
    const sections = []
    //console.log('this.scoringData.hiddenSections from prepHeader', JSON.parse(JSON.stringify(this.scoringData.hiddenSections)))
    //console.log('this.scoringData from prepHeaderSectionInfo', this.scoringData.sectionPossibleScores);
    for (const section of this.scoringData.AnswerScoreMap){
      const sectionInfo = {
        id:section.sectionId,
        score: this.scoringData.sectionScores[this.getSectionIndex(section.sectionId)].score,
        maxScore:this.scoringData.sectionPossibleScores[this.getSectionIndex(section.sectionId)].maxScore,
        title:UtilService.findObj(section.sectionTranslations, 'sectionTranslationLanguageId', this.sharedDataService.getLanguageIdForForm()).sectionTranslationTitle,
        hidden: this.scoringData.hiddenSections.includes(parseInt(section.sectionId))
      }
      if(!sectionInfo.score){
        //Backup to ensure something is rendered even if there is an error
        sectionInfo.score = 0
      }
      // console.log('sectionInfo in here', sectionInfo);
      sections.push(sectionInfo)
    }
    return sections
  }
  @ViewChild(SingleChoiceFieldComponent) radioButtonComponent: SingleChoiceFieldComponent;
  processScoringData(scoreOptions:any){
    // console.log('---------------------')
    // console.log('scoreOptions', scoreOptions);
    // console.log('this.sharedDataService.savedScoreStateAvailable', this.sharedDataService.savedScoreStateAvailable);
    // console.log('this.loadingFormSavedState', this.loadingFormSavedState);
    // console.log('this.sharedDataService.savedFormStateScoreData', this.sharedDataService.savedFormStateScoreData);
    // console.log('this.sharedDataService.scoreStateData', this.sharedDataService.scoreStateData);
    // console.log('---------------------')
    if(this.sharedDataService.savedScoreStateAvailable || this.loadingFormSavedState){
      // console.log('this.sharedDataService.savedScoreStateAvailable', this.sharedDataService.savedScoreStateAvailable);
      // console.log('this.loadingFormSavedState', this.loadingFormSavedState);
      if (this.sharedDataService.savedScoreStateAvailable === true) {
        this.scoringData = this.sharedDataService.scoreStateData;
      }
      //this.recalculateAllVisibleSections();
      //this.scoringData = JSON.parse(JSON.stringify(this.sharedDataService.scoreStateData))

      const invalidatedQuestions = new Set();
      if (this.sharedDataService.scoreStateData && this.sharedDataService.scoreStateData.userAnswerData) {
        for(const answer of this.sharedDataService.scoreStateData.userAnswerData) {
          if(answer.score === "/") {
            invalidatedQuestions.add(answer.questionId);
          }
        }
      }

      if (this.sharedDataService.scoreStateData && this.sharedDataService.scoreStateData.sectionScores) {
        for(const section of this.sharedDataService.scoreStateData.sectionScores){
          section.score = 0
          for(const answer of this.sharedDataService.scoreStateData.userAnswerData){
          if (answer.score !=="/" && answer.section === section.Id && !invalidatedQuestions.has(answer.questionId)){
            section.score = section.score + answer.score
          }}
          for(let section of this.sharedDataService.scoreStateData.sectionPossibleScores){
            try{
              if(!section.maxScore && section.maxScore !=0){
                section.maxScore = 0
              }
            } catch{
              const newSection = {id:section.id, maxScore:0}
              section = newSection
            }
          }
        }
      }

      this.sharedDataService.scoreStateData = {}
      this.cancelUncheckForSavedState = true
    } else {
      this.scoringData.enabled = (scoreOptions !=null ? scoreOptions.isFormScoringEnabled : false)
      this.scoringData.showScoreInApp = (scoreOptions != null ? scoreOptions.isShowScoreInApp : false)
      this.scoringData.showSectionScoreinPDF = (scoreOptions != null ? scoreOptions.isShowSScoreInPDF : false)
      this.scoringData.showTotalScoreInPDF = (scoreOptions != null ? scoreOptions.isShowTScoreInPDF : false)
      this.scoringData.AnswerScoreMap = scoreOptions.sections
      //this.scoringData.AnswerScoreMap = JSON.parse(JSON.stringify(scoreOptions?.sections || []));
    }
    console.log("scoredata: ", this.scoringData)

    //Calculate the scores, so they can be displayed
    this.evaluateHiddenValues()
    if(this.firstRun){
      this.firstRun = false
      // this.utilService.initaliseHiddenScoringElements(this.scoringData.AnswerScoreMap)
      // this.initHiddenQuestions = this.scoringData.hiddenQuestions
      // this.initHiddenSections = this.scoringData.hiddenSections
      const initValues = this.utilService.initaliseHiddenScoringElements(JSON.parse(JSON.stringify(this.scoringData.AnswerScoreMap)))
      //const initValues = this.utilService.initaliseHiddenScoringElements(this.scoringData.AnswerScoreMap)
      this.initHiddenSections = initValues[0]
      this.initHiddenQuestions = initValues[1]
    }
    this.calculateCurrentFormScore()
    if (!this.sharedDataService.savedScoreStateAvailable && !this.loadingFormSavedState){
      //this.scoringData.sectionScores = []
      this.scoringData.sectionPossibleScores = []
      this.scoringData.AnswerScoreMap.forEach((section, index) =>{
      this.scoringData.sectionScores.push({Id: section.sectionId, score:0})
      this.scoringData.sectionPossibleScores.push({Id:section.sectionId, maxScore: 0})
      const invalidatedScores = []
      for (const answer of this.scoringData.userAnswerData){
        if (answer.score === "/"){
          invalidatedScores.push(answer.questionId)
        }
      }
      this.scoringData.sectionPossibleScores[index].maxScore = this.calculatePossibleSectionScore(section.sectionId, invalidatedScores)
    })
  }
    this.sharedDataService.savedScoreStateAvailable = false
    this.loadingFormSavedState = false
    this.calculatePossibleFormScore()
    this.getCheckBoxesInPredefinedSections()
  }

  clearScoringData(){
    this.sharedDataService.scoreData = {}
    this.scoringData.userAnswerData.length = 0, this.scoringData.userAnswerData = []
    while(this.scoringData.userAnswerData.length >0){
      this.scoringData.userAnswerData.pop()
    }
    this.scoringData.enabled = this.scoringData.showScoreInApp =  this.scoringData.showSectionScoreinPDF = this.scoringData.showTotalScoreInPDF = false
    this.scoringData.sectionScores = this.scoringData.sectionPossibleScores = this.scoringData.AnswerScoreMap = this.scoringData.userAnswerData = this.scoringData.hiddenSections = this.scoringData.hiddenQuestions = this.scoringData.answersInHiddenSections = this.answersInHiddenForDeselect =[]
    this.scoringData.formScore = this.scoringData.formPossibleScore = this.scoringData.formScorePercent= 0
  }

  getScoreFromID(data){
    let sectionID = 0
    this.scoringData.AnswerScoreMap.forEach(section =>{
      section.questions.forEach(question => {
        if (question.questionId === data.questionId){
          for (const answer of question.answerChoiceAttributes){
            if(answer.answerChoiceAttributeId === data.answerChoiceAttributeId){
              //const newAnswer = {questionId:question.questionId, answerChoiceId:data.answerChoiceAttributeId, section: section.sectionId,score:null, hidden:question.questionIsHidden}
              const newAnswer = {questionId:question.questionId, answerChoiceId:data.answerChoiceAttributeId, section: section.sectionId,score:null, hidden:this.scoringData.hiddenQuestions.includes(question)}
              if(answer.answerChoiceAttributeScoreOrWeight !== "/"){
                newAnswer.score = Number(answer.answerChoiceAttributeScoreOrWeight)
              } else {
                newAnswer.score = "/"
              }
              sectionID = section.sectionId
              //Check if single or mutli choice, then update user answer data as appropriate
              if ('isChecked' in data){
                if(data.isChecked){
                  this.scoringData.userAnswerData.push(newAnswer)
                } else {
                  this.scoringData.userAnswerData = this.scoringData.userAnswerData.filter(answer => answer.answerChoiceId !== newAnswer.answerChoiceId)
                }
              } else {
                for (const answer of this.scoringData.userAnswerData){
                  //if unchecking remove the answer and return
                  if(answer.answerChoiceId === data.answerChoiceAttributeId){
                    if (!  (this.scoringData.answersInHiddenSections?.some(obj => obj.answerChoiceId === answer.answerChoiceId)) ||(this.answersInHiddenForDeselect?.some(obj => obj.answerChoiceId === answer.answerChoiceId))){
                      const newScore = this.scoringData.sectionScores[this.getSectionIndex(sectionID)].score - answer.score
                      this.scoringData.sectionScores[this.getSectionIndex(sectionID)].score = newScore
                      this.scoringData.userAnswerData = this.scoringData.userAnswerData.filter(answer => answer.questionId !== newAnswer.questionId)
                      return
                    } else{
                      this.answersInHiddenForDeselect.push(answer)
                    }
                  }
                }
                //remove any other answers for this question then add this one
                this.scoringData.userAnswerData = this.scoringData.userAnswerData.filter(answer => answer.questionId !== newAnswer.questionId)
                // console.log('------------------- this.scoringData -------------', this.scoringData);
                if (this.recentlyRemovedSections.includes(newAnswer.section)) {
                  console.warn(`Preventing re-add of answer from recently removed section ${newAnswer.section}`);
                  return;
                }
                this.scoringData.userAnswerData.push(newAnswer)
              }
            }
          }
        }
        const uniqueIds = []
        const uniqueAnswers = []
        for(const answer of this.scoringData.userAnswerData){
          if(!uniqueIds.includes(answer.answerChoiceId)){
            uniqueAnswers.push(answer)
            uniqueIds.push(answer.answerChoiceId)
          }
        }
        this.scoringData.userAnswerData =  uniqueAnswers
        //this.scoringData.userAnswerData =  JSON.parse(JSON.stringify(uniqueAnswers))          
    });
  })
  this.calculateCurrentSectionScore(sectionID)
  }

  resolveBrokenAnswerSectionId(targetAnswerId){
    let sectionId = 0
    for (const section of this.scoringData.AnswerScoreMap){
      section.questions.forEach((question)=>{
        for(const answer of question.answerChoiceAttributes){
          if(answer.answerChoiceAttributeId === targetAnswerId){
            sectionId =  section.sectionId
          }
        }
      })
    }
    return sectionId
  }

  saveHiddenSectionAnswers(sectionId, userAnswerData){
    for (const answer of this.scoringData.userAnswerData){
      if(answer.section = sectionId && !(this.scoringData.answersInHiddenSections?.some(obj => obj.answerChoiceId === answer.answerChoiceId))){
        if(answer.section === true){
          answer.section = this.resolveBrokenAnswerSectionId(answer.answerChoiceId)
        }
        this.scoringData.answersInHiddenSections.push(answer)
      }
    }
  }
  removeHiddenSectionAnswers(sectionId, userAnswerData){
    try{
    const section = this.scoringData.AnswerScoreMap[this.getSectionIndex(sectionId)]
    if(section.isAccidentReportSection || section.isHAVSection || section.isRiskAssessmentSection || !section){
      return
      }
    } catch{}
    
    let updatedAnswers = []
    for(const answer of this.scoringData.userAnswerData){
      const isHidden = this.checkIsQuestionHidden(answer)
      if(!this.scoringData.hiddenSections.includes(answer.section) && !isHidden){
        updatedAnswers.push(answer)
      }
    }
    for (const section of this.scoringData.AnswerScoreMap){
      if (section.sectionIsHidden){
        updatedAnswers = updatedAnswers.filter(entry => entry.section !== sectionId)
      }
    }
    /*if(this.scoringData.AnswerScoreMap[this.getSectionIndex(sectionId)].sectionIsHidden){
      updatedAnswers = updatedAnswers.filter(entry => entry.section !== sectionId)
    }*/
    this.scoringData.userAnswerData = updatedAnswers 
    //this.scoringData.sectionScores[this.getSectionIndex(sectionId)].score =this.calculateCurrentSectionScore(sectionId, true)
    // this.scoringData.sectionPossibleScores[this.getSectionIndex(sectionId)].maxScore = this.calculatePossibleSectionScore(sectionId)
    this.calculateCurrentSectionScore(sectionId, true)
    this.calculatePossibleSectionScore(sectionId)
  }
  async hideinitHiddenQs(questions, sectionDisplayOrder){
    let index = 0
    let sectionId = 0
        for(const section of this.scoringData.AnswerScoreMap){
          if(section.sectionDisplayOrder === sectionDisplayOrder){
            index = this.getSectionIndex(section.sectionId)
            sectionId = section.sectionId
          }
        }
    this.resetLogics(questions, sectionDisplayOrder, index)
    this.scoringData.userAnswerData = this.scoringData.userAnswerData .filter(entry => entry.section !== this.scoringData.AnswerScoreMap[index].sectionId)
    this.scoringData.sectionScores[this.getSectionIndex(sectionId)].score = this.calculateCurrentSectionScore(sectionId, true)
    //this.scoringData.sectionPossibleScores[this.getSectionIndex(sectionId)].maxScore = this.calculatePossibleSectionScore(sectionId) 
    this.calculatePossibleFormScore()
  }

 checkIsQuestionHidden(answer){
  // if(this.scoringData.hiddenQuestions.includes(answer.questionId)){
  //   return true
  // }
  // return false
  // test commit
  for(const section of this.scoringData.AnswerScoreMap){
    if(section.sectionId === answer.section){
      for (const question of section.questions){
        if(question.questionId === answer.questionId){
          if(question.questionIsHidden){
            return true
          } else{
            return false
            
          }
        }
      }
    }
  }
}

 resetLogics(questions, sectionOrder,sectionIndex){
  for(const question of questions){
    if(this.initHiddenQuestions.includes(question.questionId)){
      const target = `Question_${(sectionOrder)-1}_${(question.questionDisplayOrder)-1}_${question.sectionID}_${question.questionId}`
      const element = document.getElementById(target)
      if(element != null){
        element.style.display = "none"
      }
    }
    const reconstructedValue = this.reconstructCurrentAnswerValue(question)
    if (reconstructedValue !== undefined) {
      this.utilService.checkAndApplyLogic(question, reconstructedValue, {} as any, this.scoringData.AnswerScoreMap, sectionIndex)
    } else {
      this.utilService.resetAppliedLogicByQuestion(question,this.scoringData.AnswerScoreMap,sectionIndex,{})
    }
    if(question.selectedAnswerTypeId === 1){
      // scs reset
      
    } else if (question.selectedAnswerTypeId === 2){
      // mcs reset - Notes: This should reset the logic functions based on the answer choice, not the question as in the above utilService function, it is unclear if this step is necesary at this time (21/8/24).
      //Notes: It appears that the issue relating to scs logic not properly hiding questions further down the chain when a question's chosen answer is changed (as opposed to choosing deselect or another question entirely)
      //Notes(cont.) might be related to some of the following points: 1.resetAppliedLogicByQuestion going on the question rather than choices within it. 2. this.resetLogics() not being called for the previously stated reason.
      //Notes(cont.): 3.The order of calls resulting from the logic action being called almost immediately while the above reset is much further down the stack. 4. The lack of a specific reset for each answerChoice, similar to MCS.
    }
  }
 }

  private reconstructCurrentAnswerValue(question): any {
    if (question.selectedAnswerTypeId === EnumService.CustomAnswerType.SingleChoiceSet
      || question.selectedAnswerTypeId === EnumService.CustomAnswerType.ConfirmationBox) {
      const answer = this.scoringData.userAnswerData.find(a => a.questionId === question.questionId)
      return answer ? answer.answerChoiceId : undefined
    }
    if (question.selectedAnswerTypeId === EnumService.CustomAnswerType.MultipleChoiceSet) {
      if (!question.answerChoiceAttributes?.length) return undefined
      const value = {}
      for (const choice of question.answerChoiceAttributes) {
        value[choice.answerChoiceAttributeId] = this.scoringData.userAnswerData.some(
          a => a.questionId === question.questionId && a.answerChoiceId === choice.answerChoiceAttributeId
        )
      }
      return value
    }
    return undefined
  }

  evaluateHiddenValues(){
    //Ensure that the hidden and visible info is accurate, update as needed
    let unhiddenSection = 0
    for(const section of this.scoringData.AnswerScoreMap){
      try{
      if(section.sectionIsHidden){
        if(!this.initHiddenSections.includes(section.SectionId)){
          setTimeout(()=>{
            //this.saveHiddenSectionAnswers(section.sectionId, this.scoringData.userAnswerData)
            this.removeHiddenSectionAnswers(section.sectionId, this.scoringData.userAnswerData)
            if(!this.scoringData.hiddenSections.includes(section.sectionId)){
              this.scoringData.hiddenSections.push(section.sectionId)
            }
          },150)
        }
      } else if(this.scoringData.hiddenSections.includes(section.sectionId)){
        this.scoringData.hiddenSections = this.scoringData.hiddenSections.filter(entry => entry !== section.sectionId)
        //console.log('this.scoringData.hiddenSections', JSON.parse(JSON.stringify(this.scoringData.hiddenSections)));
        unhiddenSection = section.sectionId
        setTimeout(()=>{
          this.hideinitHiddenQs(section.questions, section.sectionDisplayOrder)
        },200)

        this.answersInHiddenForDeselect = []


      // } else if(this.scoringData.hiddenSections.includes(section.sectionId)){
      } 
      // TEMP COMMENT
      // else if(!this.initHiddenSections.includes(section.SectionId)){
      //   // this.scoringData.hiddenSections = this.scoringData.hiddenSections.filter(entry => entry !== section.sectionId)
      //   // unhiddenSection = section.sectionId
      //   // setTimeout(()=>{
      //   //   this.hideinitHiddenQs(section.questions, section.sectionDisplayOrder)
      //   // },200)

      //   // this.answersInHiddenForDeselect = []
      //  // this.scoringData.answersInHiddenSections = this.scoringData.answersInHiddenSections.filter(entry => entry.section !== section.sectionId)
      //   setTimeout(()=>{
      //     //this.saveHiddenSectionAnswers(section.sectionId, this.scoringData.userAnswerData)
      //     this.removeHiddenSectionAnswers(section.sectionId, this.scoringData.userAnswerData)
      //     //if(!this.scoringData.hiddenSections.includes(section.sectionId)){
      //       //this.scoringData.hiddenSections.push(section.sectionId)
      //     //}
      //   },150)
      // } 
      else{
        this.removeHiddenSectionAnswers(section,this.scoringData.userAnswerData)
      }
    }catch(error){
      if((!error.toString().includes("setting 'maxScore'")) && (!error.toString().includes("setting 'score'")) ){
        console.warn("Error evaluating visiblility of section: ",section.sectionId," (Ignore if 0 or if it has no scoring)")
      }
    }
  }
  // console.log('++++++++')
  // console.log('this.scoringData.userAnswerData', this.scoringData.userAnswerData)
  // console.log('++++++++')
  this.checkChosenVisibleAnswers(this.scoringData.userAnswerData,unhiddenSection)
}

async checkChosenVisibleAnswers(answerData,sectionToRecalculate = 0) {
  //Make sure any visible questions the user has answered are checked
  //console.log("state info for check chosen visible: ", this.sharedDataService.savedFormStateData, answerData, this.scoringData.hiddenSections)
  // console.log('answer data', answerData)
  if(!this.scoringData.enabled || this.isRestoringState){
    return
  }
  setTimeout(()=>{
  const radioBtns = document.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;
  const ionChecks = document.querySelectorAll('ion-checkbox')
  //this.getCheckBoxesInPredefinedSections()
  setTimeout(() => {
    this.scoringData.userAnswerData = answerData
  }, 100);
  //console.log('this.scoringData.userAnswerData', this.scoringData.userAnswerData);
  for (let i = 0; i <radioBtns.length; i++){
    
    let sibling: HTMLLabelElement = document.createElement('label');
    radioBtns[i].parentNode.childNodes.forEach((node)=>{
      if (node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName === 'LABEL') {
        sibling = node as HTMLLabelElement;
      }
    })
    let answered = false;
    for (const answer of answerData){
        //console.log("label vs id: ", answer.answerChoiceId, ",",sibling.htmlFor,",", sibling.htmlFor == answer.answerChoiceId)
      try{
        if(radioBtns[i].id == answer.answerChoiceId || sibling.htmlFor == answer.answerChoiceId){
          if(!this.scoringData.hiddenSections.includes(answer.section)){
            radioBtns[i].checked = true
            answered = true
          }
          // console.log("checking radio: ", radioBtns[i].id)
          // console.log("checking radio: ", radioBtns[i].checked)
          // console.log('this.scoringData.hiddenSections', this.scoringData.hiddenSections);
          // console.log('answer.section', answer.section);
        }
      } catch{}
      
    }
    // if(!answered){
    //   radioBtns[i].checked = false
    // } 
  }
  const checkedBoxes = []
  for (let i = 0; i < ionChecks.length; i++){
    for (const answer of answerData){
      if(ionChecks[i].value === answer.answerChoiceId){
        ionChecks[i].checked = true
        checkedBoxes.push(ionChecks[i])
      }
    }
  }

   //save user selected other impacted elements not in a predefined section
  
  for(const Component in this.sharedDataService.savedFormStateData){
    const itemId = Component.split("FormControl_")[1]
    const questionComponent = document.querySelectorAll(`[id*="${itemId}"]`) as NodeList
    //console.log("comp:", questionComponent)
    try{
      //Restore any unchecked app-confirm-box elements
      if(Date.now() < this.sharedDataService.lastFormLaunch +1000){
      for (const node of Array.from(questionComponent)){
        for (const child of Array.from(node.childNodes)){
          if(child.nodeName =="APP-CONFIRM-BOX-FIELD" ){
            const ionCheckbox = (child as HTMLElement).querySelector('ion-checkbox');
              this.confirmBoxes.push(ionCheckbox)
              for(const [key, value] of this.sharedDataService.savedFormStateData ){
                if(key.split("_").pop() === ionCheckbox.id.toString()){
                  if(value){    
                    ionCheckbox.click()
                  }  
                }
              }
            } 
          }
        }
      }
    }catch{}
    // try{
    //   //TODO: add unique 3d matrix check 
    //   const results = Object.values(this.sharedDataService.savedFormStateData[Component.toString()])
    //   let index:number = 0;
    //   for (const node of Array.from(questionComponent)){
    //     for (const child of Array.from(node.childNodes)){
    //       if(child.nodeType == 1){
    //         const subElement = child as Element
    //         if(subElement.className === "col-view" &&subElement.childNodes[0].nodeType === 1){
    //           const ionCheckbox = (child as HTMLElement).querySelector('ion-checkbox');
    //           if(results[index] == true){
    //             console.log('results[index]', results[index]);
    //             ionCheckbox.click()
    //           }
    //           index +=1
    //         }
    //       }
    //     }
    //   }
    // } catch{}


  }
  if(sectionToRecalculate !=0){
    this.calculateCurrentSectionScore(sectionToRecalculate)
  }

},100)
}

getCheckBoxesInPredefinedSections(){
  const savedBoxes =[]
  //Add any future sections that need handling here (or figure out why these arent on the answer list)
  const accidentReportAboutSection = document.getElementById("AccidentReportAboutSection")
  const riskAssessmentSection = document.getElementsByName("PersonsExposed")
  if(accidentReportAboutSection !=null){
    for (const node of Array.from(accidentReportAboutSection.childNodes)){
      if(node.nodeName === "ION-ITEM"){
        for (const subNode of Array.from(node.childNodes)){
          if(subNode.nodeName === "ION-CHECKBOX"){
            savedBoxes.push(subNode)
          }
        }
      }
    }
  }
  if(riskAssessmentSection != null){
    for(const section of Array.from(riskAssessmentSection)){
      for (const node of Array.from(section.childNodes)){
        if(node.nodeName === "ION-ITEM"){
          for (const subNode of Array.from(node.childNodes)){
            if(subNode.nodeName === "ION-CHECKBOX"){
              savedBoxes.push(subNode)
            }
          }
        }
      }
    }
  }
  this.predefinedSectionBoxes = savedBoxes
}

unCheckAll(){
  if(this.cancelUncheckForSavedState){
    setTimeout(() => {
      this.cancelUncheckForSavedState = false
    }, 200);
    return
  }
  const radioButtons = document.querySelectorAll('input[type="radio"]');
  radioButtons.forEach((radio: HTMLInputElement) => {
    radio.checked = false;
  });
  const checkboxes = document.querySelectorAll('ion-checkbox');
    checkboxes.forEach(async (checkbox: HTMLIonCheckboxElement) => {
      await checkbox.componentOnReady();  // Ensure the component is ready
      checkbox.checked = false;
    });
    const formValues = {
      radioValues: Array.from(document.querySelectorAll('input[type="radio"]')).map((radio: HTMLInputElement) => radio.checked = false),
      checkboxValues: Array.from(document.querySelectorAll('ion-checkbox')).map((checkbox: HTMLIonCheckboxElement) => checkbox.checked = false) ,
    };

}
  updateFormScore(data) {
    this.getScoreFromID(data)
    //The rest of this is unused code from the old devs
    let event = data.event;
    let item = data.item;
    let score = 0;
    switch (data.type) {
      case 'checkbox':
        score = parseInt(item ? item.answerChoiceAttributeScoreOrWeight : 0);
        if (event.detail.checked) {
          this.scoringData.formScore += score;
        } else {
          this.scoringData.formScore -= score;
        }
        break;
      // weird logic due to the having to capture the event from the click event.
      case 'radiogroup':
        this.processSingleChoiceState(data);
        break;
    }
    this.observablesService.publishSomeData(
      EnumService.ObserverKeys.FORM_SCORE_CHANGED, {}
    );
  }
  prepSaveStateScore(){
    //Note: just returning this.scoringData excludes the answerScoreMap and returns some data in a format we dont want
    const userAnswers = []
    for  (const answer of this.scoringData.userAnswerData){
      userAnswers.push(answer)
    }
    const dataForState = {
      enabled:this.scoringData.enabled, userAnswerData:userAnswers, AnswerScoreMap: this.scoringData.AnswerScoreMap,
      showScoreInApp:this.scoringData.showScoreInApp,showTotalScoreInPDF:this.scoringData.showTotalScoreInPDF, showSectionScoreinPDF:this.scoringData.showSectionScoreinPDF,
      hiddenSections: this.scoringData.hiddenSections, hiddenQuestions:this.scoringData.hiddenQuestions,
      formScore:this.scoringData.formScore,formPossibleScore:this.scoringData.formPossibleScore, formScorePercent:this.scoringData.formScorePercent,
      sectionScores:this.scoringData.sectionScores, sectionPossibleScores:this.scoringData.sectionPossibleScores}
    return dataForState
  }
  updateFormScoreFromSavedState(data) {
    this.loadingFormSavedState = true
    this.cancelUncheckForSavedState = true
    this.isRestoringState = true
    //this.evaluateHiddenValues();
    // OLD CODE
    // try{
    //   if(data.enabled){
    //     this.sharedDataService.scoreStateData = data
    //     //this.sharedDataService.scoreStateData = JSON.parse(JSON.stringify(data))
    //   }
    // } catch{}
    // NEW CODE
    try {
      if (data?.enabled) {
          // Preserve existing AnswerScoreMap if it exists
        const existingAnswerScoreMap = this.scoringData.AnswerScoreMap?.length ? 
            this.scoringData.AnswerScoreMap : 
            data.AnswerScoreMap;

        // Create a new scoring data object with all properties
        const newScoringData = {
          ...this.scoringData, // Current state
          ...data,            // Saved state data
          AnswerScoreMap: existingAnswerScoreMap,
          userAnswerData: data.userAnswerData || [],
          // hiddenQuestions: data.hiddenQuestions?.filter(qId => {
          //   const section = data.AnswerScoreMap?.find(s => 
          //     s.questions?.some(q => q.questionId === qId)
          //   );
          //   return section && data.hiddenSections?.includes(section.sectionId);
          // }) || [],
          hiddenQuestions: data.hiddenQuestions || [],
          hiddenSections: data.hiddenSections || []
        };

        this.scoringData.hiddenQuestions = this.scoringData.hiddenQuestions.filter(qId => {
          const section = this.scoringData.AnswerScoreMap?.find(s =>
            s.questions?.some(q => q.questionId === qId)
          );
          return section && this.scoringData.hiddenSections.includes(section.sectionId);
        });

        // Update the scoring data
        this.scoringData = newScoringData;

        // console.log('data', data);
        // console.log('this.scoringData', this.scoringData);

        // Reinitialize section scores based on restored data
        this.scoringData.sectionScores = data.sectionScores || [];
        this.scoringData.sectionPossibleScores = data.sectionPossibleScores || [];

        // this.sharedDataService.savedScoreStateAvailable || this.loadingFormSavedState

        // setTimeout(() => {
        this.evaluateHiddenValues();
        //this.recalculateAllSections(); //-- check this for the return from signoff issue
        //Recalculate all scores
        this.calculateCurrentFormScore();
        this.calculatePossibleFormScore();
        // }, 100);

        // console.log('------------- data.userAnswerData',  data.userAnswerData);
        // console.log('------------- this.scoringData.userAnswerData', this.scoringData.userAnswerData);

        setTimeout(() => {
          this.isRestoringState = false; // <-- Reset flag
          this.checkChosenVisibleAnswers(this.scoringData.userAnswerData);
        }, 50);

        // Update shared state
        this.sharedDataService.scoreStateData = {...this.scoringData};
      }
    } catch(err) {
        console.error('Error updating form score from saved state:', err);
    }
  }

  processSingleChoiceState(data) {
    let answer;
    let score:any = 0;
    let event = data.event;

    if (event.detail.value === undefined){

    } else {
      answer = this.getAnswerItemById(event.detail.value, data.list);
      try{
        score = Number(answer.answerChoiceAttributeScoreOrWeight);
      } catch{
        score = "/"
      }
    } 
    
    //Traverse the list find the item with value X then pull its score and assign here.
    const previousScoreSet = event.target.hasAttribute('previousScore');
    let scorePrevious = (previousScoreSet ? event.target.attributes['previousScore'].value : 0);
      
    if (scorePrevious != 0 && answer === undefined) {
      this.scoringData.formScore -= scorePrevious;
      if (!previousScoreSet) {
        event.target.setAttribute('previousScore', 0);
      } else {
        event.target.attributes['previousScore'].value = 0;
      }
    }
    
    if (scorePrevious == 0 && answer === undefined) {
          ///NOTIFIN
    } 
    if (scorePrevious == 0 && answer != undefined) {

      this.scoringData.formScore += score;
      if (!previousScoreSet) {
        event.target.setAttribute('previousScore', score);
      } else {
        event.target.attributes['previousScore'].value = score;
      }
    }
    if (scorePrevious != 0 && answer != undefined) {

      this.scoringData.formScore -= scorePrevious;
      this.scoringData.formScore += score;
      if (!previousScoreSet) {
        event.target.setAttribute('previousScore', score);
      } else {
        event.target.attributes['previousScore'].value = score;
      }
    }
  }

  getAnswerItemById(answerId, list) {
    let result: any;
    list.forEach((answer) => {
      if (answer.answerChoiceAttributeId === answerId) {
        result = answer;
      }
    });
    return result;
  }

  initScoreFromRelaunchData(relaunchAnswers: any[]) {
    if (!relaunchAnswers?.length || !this.scoringData.AnswerScoreMap?.length) return;

    for (const relaunchAnswer of relaunchAnswers) {
      for (const section of this.scoringData.AnswerScoreMap) {
        const question = section.questions?.find(q => q.questionId === relaunchAnswer.questionID);
        if (!question) continue;

        if (relaunchAnswer.singleChoiceValueID != null) {
          const attr = question.answerChoiceAttributes?.find(
            a => a.parentAnswerChoiceQuestionAttributeId === relaunchAnswer.singleChoiceValueID
              || a.answerChoiceAttributeId === relaunchAnswer.singleChoiceValueID
          );
          if (attr) {
            this.scoringData.userAnswerData = this.scoringData.userAnswerData.filter(
              a => a.questionId !== question.questionId
            );
            const score = attr.answerChoiceAttributeScoreOrWeight === '/'
              ? '/'
              : Number(attr.answerChoiceAttributeScoreOrWeight);
            this.scoringData.userAnswerData.push({
              questionId: question.questionId,
              answerChoiceId: attr.answerChoiceAttributeId,
              section: section.sectionId,
              score,
              hidden: question.questionIsHidden || false
            });
          }
        } else if (relaunchAnswer.multipleChoiceValueIDs != null) {
          const ids = String(relaunchAnswer.multipleChoiceValueIDs)
            .split(',')
            .map(id => Number(id.trim()))
            .filter(id => !isNaN(id));
          for (const id of ids) {
            const attr = question.answerChoiceAttributes?.find(
              a => a.parentAnswerChoiceQuestionAttributeId === id
                || a.answerChoiceAttributeId === id
            );
            if (attr) {
              const score = attr.answerChoiceAttributeScoreOrWeight === '/'
                ? '/'
                : Number(attr.answerChoiceAttributeScoreOrWeight);
              this.scoringData.userAnswerData = this.scoringData.userAnswerData.filter(
                a => a.answerChoiceId !== attr.answerChoiceAttributeId
              );
              this.scoringData.userAnswerData.push({
                questionId: question.questionId,
                answerChoiceId: attr.answerChoiceAttributeId,
                section: section.sectionId,
                score,
                hidden: question.questionIsHidden || false
              });
            }
          }
        }
      }
    }

    this.scoringData.hiddenSections = this.scoringData.AnswerScoreMap
      .filter(s => s.sectionIsHidden)
      .map(s => s.sectionId);

    this.recalculateAllSections();
    this.calculateCurrentFormScore();
  }

  makeRelaunchReflectSaveState(relaunchData, state){
    const formattedSaveStateAnswers = Object.entries(state).map(([key, value]) => {
      const transformedKey = key.split('_').pop();
      return { key: transformedKey, value };
    });
    try{
    for(const rlAnswer of relaunchData){
        const matchingQuestion = formattedSaveStateAnswers.find((answer) => answer.key == rlAnswer.questionID)
        if(matchingQuestion){
          switch(rlAnswer.answerTypeID){
            case 1:
              if(rlAnswer.singleChoiceValueID != matchingQuestion.value){
                rlAnswer.singleChoiceValueID = matchingQuestion.value
              }
              break;
            case 2:
              if(rlAnswer.multipleChoiceValueIDs != matchingQuestion.value){
                const multiChoiceAnswers = Object.entries(matchingQuestion.value).map(([key, value]) => {
                  const transformedKey = key.split('_').pop();
                  return { key: transformedKey, value };
                })
                let seclectionString = ""
                for (const answer of multiChoiceAnswers){
                  if(answer.value){
                    seclectionString += `${answer.key},`
                  }
                }
                rlAnswer.multipleChoiceValueIDs = seclectionString.slice(0,-1)
              }
              break;
            case 3:
            case 4:
              if(rlAnswer.textValue != matchingQuestion.value){
                rlAnswer.textValue = matchingQuestion.value
              }
              break;
            case 5:
              if(rlAnswer.integerValue != matchingQuestion.value){
                rlAnswer.integerValue = matchingQuestion.value
              }
              break;
            case 6:
              if(rlAnswer.decimalValue != matchingQuestion.value){
                rlAnswer.decimalValue = matchingQuestion.value
              }
              break;
            case 7:
              if(rlAnswer.dateValue != matchingQuestion.value){
                rlAnswer.dateValue = matchingQuestion.value.toString()
              }
              break;
            case 8:
              if(rlAnswer.timeValue != matchingQuestion.value){
                const date = new Date( matchingQuestion.value.toString());
                let hours = date.getHours();
                const minutes = date.getMinutes();
                const isAM = hours < 12;
                hours = hours % 12 || 12;
                const formattedTime = `${hours}:${minutes.toString().padStart(2, "0")}${isAM ? "am" : "pm"}`;
                rlAnswer.timeValue = formattedTime
              }
              break;
            case 9:
              if(rlAnswer.dateTimeValue != matchingQuestion.value){
                rlAnswer.dateTimeValue = matchingQuestion.value
              }
              break;
              case 10:
                rlAnswer.imageVideoDocFileDetails = matchingQuestion.value
                if(Array.isArray(matchingQuestion.value)){
                  rlAnswer.imageVideoFileName = ""
                  for (const file of matchingQuestion.value){
                    console.log(">>>>",file.name.split(".").pop() )
                    if (file.name.split(".").pop() === "jpg" || file.name.split(".").pop() === "mp4" && rlAnswer.imageVideoFileName === ""){
                      rlAnswer.imageVideoFileName = file.name
                    }
                  }
                }
                break;
            case 11:
              console.log("dropdown state", rlAnswer, matchingQuestion.value)
              break;
            case 14:
              if(rlAnswer.isConfirmBoxChecked != matchingQuestion.value){
                rlAnswer.isConfirmBoxChecked = matchingQuestion.value
              }
              break;
            case 15:
              if(rlAnswer.isConfirmBoxChecked != matchingQuestion.value){
                rlAnswer.isConfirmBoxChecked = matchingQuestion.value
              }
              break;
            case 16:
              if(rlAnswer.matrixAnswer != matchingQuestion.value){
                rlAnswer.matrixAnswer = matchingQuestion.value
              }
              break;
            case 17:
              if(rlAnswer.signatureAnswer != matchingQuestion.value){
                rlAnswer.signatureAnswer = matchingQuestion.value
              }
              break;
              //11 is dropdown, 12 is location select, 13 is body part select (can be ignored since rl ignores fixed segments)
          }
        }
      }
      return relaunchData
  } catch{
    return state
  }
}
}
